/*
 * Load the BundleInformation object into the queued bundle card HTML element
 *
 * @param {object} queued_plan_card - The queued plan card 2 HTML element
 * @param {object} bundle_info - The BundleInformation object
 * */
function loadQueuedPlanCardInformation(queued_plan_card, bundle_info, use_lowercase_units = false, productName = null) {
	let unit = window.esimCardStrings.gigabyte;

	let isTravelPassOriginal = false;
	if(bundle_info.name.includes('travelpass') && bundle_info.name.includes('x12')){
		isTravelPassOriginal = true
	}

	let isTravelPass = false;
	if(bundle_info.name.includes('travelpass')){
		isTravelPass = true
	}

	const isFirstQueud = bundle_info.firstQueuedBundle;

	let parts = bundle_info.description.split(',');
	let country;
	if (isTravelPassOriginal){
		country = window.esimCardStrings.travelPass;
	} else if(isTravelPass){
		country = window.esimCardStrings.travelPassTopUp;
	} else if (parts.length >= 4 && parts[3].trim()) {
		country = parts[3].trim();
	} else if (productName) {
		country = productName.split(' - ')[0].replace(/\s*\d+\s*GB\b/gi, '').trim();
	} else {
		country = window.esimDetailsStrings.bundleQueued;
	}
	queued_plan_card.querySelector('#queued_plan_card_country').textContent = country;

	const formattedPurchaseDate = reformatDate(bundle_info.assignment.assignmentDateTime)
	queued_plan_card.querySelector('#queued_plan_card_purchase_date').textContent = formattedPurchaseDate;

	const initialQuantity = (bundle_info.assignment.initialQuantity / 1000000000).toString()
	const remainingQuantity = (bundle_info.assignment.remainingQuantity / 1000000000).toFixed(2).toString()

	if (bundle_info.assignment.unlimited) {
		queued_plan_card.querySelector('#queued_plan_card_data').textContent =
			window.esimCardStrings.unlimitedBundle;
	} else {
		queued_plan_card.querySelector('#queued_plan_card_data').textContent =
			initialQuantity + unit;
	}

	function setBadge(string, materialIcon){
		queued_plan_card.querySelector('#queued_plan_card_title').textContent = string
		queued_plan_card.querySelector('#queued_plan_card_icon').textContent = materialIcon
	}

	function setDescription(string){
		queued_plan_card.querySelector('#queued_plan_card_desc').textContent = string
	}

	function setExpirySection(expiryLabel){
		queued_plan_card.querySelector('#queued_plan_card_expiry_section').style.display = 'flex'
		const expiryDate = reformatDate(bundle_info.assignment.endTime, true, true)
		queued_plan_card.querySelector('#queued_plan_card_expiry_date').textContent = expiryDate
		queued_plan_card.querySelector('#queued_plan_card_expiry_label').textContent = expiryLabel
	}

	function setColours(status){
		queued_plan_card.querySelector('.queued_plan_status_badge').classList.add(`${status}-bg-color`)
		queued_plan_card.querySelector('.queued_plan_card').classList.add(`${status}-border-color`)
		queued_plan_card.querySelector('.queued_plan_card').classList.add(`${status}-font-color`)
	}

	function setPercentageBar(){
		const percentageDiff = (bundle_info.assignment.remainingQuantity / bundle_info.assignment.initialQuantity * 100).toFixed(0);
		queued_plan_card.querySelector('#queued_plan_card_loading_bar').style.display = 'block'
		queued_plan_card.querySelector('#queued_plan_loading_bar_amount').style.width = `${percentageDiff}%`
	}

	const activeString = `${remainingQuantity}${window.esimCardStrings.gigabyte} ${window.esimCardStrings.ofCapitalPrefix} ${initialQuantity}${window.esimCardStrings.gigabyte} ${window.esimCardStrings.left}` 
	const status = bundle_info.assignment.bundleState;
	setColours(status)

	let isFinalMonth = false;
	if(isTravelPassOriginal){
		let expireDate = new Date(bundle_info.assignment.endTime);
		let expireMonth = expireDate.getMonth() + 1;
		let expireYear = expireDate.getFullYear();

		let purchaseDate = new Date(bundle_info.assignment.assignmentDateTime)		 
		let purchaseMonth = purchaseDate.getMonth() + 1;
		let purchaseYear = purchaseDate.getFullYear();

		if((expireMonth === purchaseMonth) && (expireYear - purchaseYear === 1)){
			isFinalMonth = true;
		}
	}

	switch (status) {
		case 'active':
			setBadge(window.esimCardStrings.active, 'check_circle')
			setDescription(activeString)
			if(isTravelPassOriginal && !isFinalMonth){
				setExpirySection(window.esimCardStrings.refreshesOn)
			} else {
				setExpirySection(window.esimCardStrings.expiresOn)
			}
			setPercentageBar()
			break;
		case 'queued':
			setBadge(window.esimCardStrings.queued, 'access_time')
			isTravelPass ? setDescription(window.esimCardStrings.becomeActiveTravelPass) 
			: isFirstQueud ? setDescription(window.esimCardStrings.becomeActiveNeedInstall) 
			: setDescription(window.esimCardStrings.becomeActive)
			break;
		case 'depleted':
			setBadge(window.esimCardStrings.depleted, 'clear')
			setDescription(activeString)
			setPercentageBar()
			if(isTravelPassOriginal){
				setExpirySection(window.esimCardStrings.refreshesOn)
			}
			break;
		case 'expired':
			setBadge(window.esimCardStrings.expired, 'clear')
			setDescription(activeString)
			setExpirySection(window.esimCardStrings.expiredOn)
			break;
		default:
			setBadge('Error', 'error')
			setDescription('Status not recognised.')
			setColours('queued')
	}
}